$(function(){
//   // スクロールでロゴ非表示
//   function displayLogo(){
//     var scrollTop = $(window).scrollTop();
//     if (scrollTop > 300) {
//       $(".sitename").fadeOut(400);
//     } else {
//       $(".sitename").fadeIn(200).css('paddingBottom',scrollTop+'px');
//     }
//   }
//   $(window).on('load scroll', displayLogo);
  //toTopの表示・非表示
  function displayToTop(){
    var scrollTop = $(window).scrollTop();
    if (scrollTop < 300) {
      $(".to-page-top").fadeOut();
    } else {
      $(".to-page-top").fadeIn();
      $(".to-page-top a").smoothScroll({offset: 0});
    }
  }
  $(window).on("load scroll", displayToTop);
  $(".navbar-toggler").click(function(){
    $(".menu1").toggleClass("menuclick1");
    $(".menu2").toggleClass("menuclick2");
    $(".menu3").toggleClass("menuclick3");
  });
//
  if ($('body').hasClass('top')) {
    $('#feature').slick({
      infinite: true,
      autoplay: true,
      fade: true,
      autoplaySpeed: 4000,
      speed: 1200,
      arrows: false
    });
  }

  // topics side
  if ($('body').hasClass('topics')) {
    $(".topics-detail #sub").load("/regnoah/topics/ #sub-content");
    $(".topics-list #sub").load("/regnoah/topics/ #sub-content");
  }
//     // feature
//     if ($('body').hasClass('jp')) {
//       var images ='<img src="/_assets/imgs/home_main-1.jpg" class="base" id="main-1"><img src="/_assets/imgs/home_main-2.jpg" class="slide" id="main-2"><img src="/_assets/imgs/home_main-3.jpg" class="slide" id="main-3">';
//       for (var i = 1; i <= 18; i++) {
//         images += '<img src="/_assets/imgs/home_main-copy-' + i + '.png" class="slide" id="main-copy-' + i + '">';
//       };
//       $('#slider').append(images);
//       //個々のスライドをレイヤー状にして非表示
//       $('.slide').css({
//         'display': 'none',
//         'position': 'absolute',
//         'margin-top': '-420px'
//       });
//       //順にフェードインで表示
//       $('#main-1').fadeIn(3000, function(){
//         $('#main-2').fadeIn(3000, function(){
//           $('#main-copy-1').delay(1000).fadeIn(600);
//           $('#main-copy-2').delay(1200).fadeIn(600);
//           $('#main-copy-3').delay(1400).fadeIn(600);
//           $('#main-copy-4').delay(1600).fadeIn(600);
//           $('#main-copy-5').delay(1800).fadeIn(600, function(){
//             $('#main-copy-6').fadeIn(600);
//             $('#main-copy-7').delay(200).fadeIn(600);
//             $('#main-copy-8').delay(400).fadeIn(600, function(){
//               $('#main-copy-9').fadeIn(600);
//               $('#main-copy-10').delay(200).fadeIn(600);
//               $('#main-copy-11').delay(400).fadeIn(600);
//               $('#main-copy-12').delay(600).fadeIn(600, function(){
//                 $('#main-copy-13').fadeIn(600);
//                 $('#main-copy-14').delay(200).fadeIn(600);
//                 $('#main-copy-15').delay(400).fadeIn(600);
//                 $('#main-copy-16').delay(600).fadeIn(600);
//                 $('#main-copy-17').delay(800).fadeIn(600);
//                 $('#main-copy-18').delay(1000).fadeIn(600, function(){
//                   $('#main-3').delay(1000).fadeIn(3000);
//                 });
//               });
//             });
//           });
//         });
//       });
//     }
//     if ($('body').hasClass('en')) {
//       var imagesEn ='<img src="/_assets/imgs/home_main-1.jpg" class="base" id="main-1"><img src="/_assets/imgs/home_main-2.jpg" class="slide-en" id="main-2"><img src="/_assets/imgs/home_main-3.jpg" class="slide-en" id="main-3">';
//       for (var j = 1; j <= 26; j++) {
//         imagesEn += '<img src="/_assets/imgs/en-home_main-copy-' + j + '.png" class="slide-en" id="main-copy-' + j + '">';
//       };
//       $('#slider-en').append(imagesEn);
//       //個々のスライドをレイヤー状にして非表示
//       $('.slide-en').css({
//       'display': 'none',
//       'position': 'absolute',
//       'margin-top': '-420px'
//       });
//       //順にフェードインで表示
//       $('#main-1').fadeIn(3000, function(){
//         $('#main-2').fadeIn(3000, function(){
//           $('#main-copy-1').delay(1000).fadeIn(600);
//           $('#main-copy-2').delay(1200).fadeIn(600);
//           $('#main-copy-3').delay(1400).fadeIn(600);
//           $('#main-copy-4').delay(1600).fadeIn(600);
//           $('#main-copy-5').delay(1800).fadeIn(600);
//           $('#main-copy-6').delay(2000).fadeIn(600);
//           $('#main-copy-7').delay(2200).fadeIn(600, function(){
//             $('#main-copy-8').delay(1000).fadeIn(600);
//             $('#main-copy-9').delay(1200).fadeIn(600, function(){
//               $('#main-copy-10').fadeIn(600);
//               $('#main-copy-11').delay(200).fadeIn(600);
//               $('#main-copy-12').delay(400).fadeIn(600);
//               $('#main-copy-13').delay(600).fadeIn(600);
//               $('#main-copy-14').delay(800).fadeIn(600, function(){
//                 $('#main-copy-15').fadeIn(600);
//                 $('#main-copy-16').delay(200).fadeIn(600, function(){
//                   $('#main-copy-17').fadeIn(600);
//                   $('#main-copy-18').delay(200).fadeIn(600, function(){
//                     $('#main-copy-19').fadeIn(600);
//                     $('#main-copy-20').delay(200).fadeIn(600);
//                     $('#main-copy-21').delay(400).fadeIn(600);
//                     $('#main-copy-22').delay(600).fadeIn(600);
//                     $('#main-copy-23').delay(800).fadeIn(600);
//                     $('#main-copy-24').delay(1000).fadeIn(600);
//                     $('#main-copy-25').delay(1200).fadeIn(600);
//                     $('#main-copy-26').delay(1400).fadeIn(600, function(){
//                       $('#main-3').delay(1000).fadeIn(3000);
//                     });
//                   });
//                 });
//               });
//             });
//           });
//         });
//       });
//     }
//     if($(window).width()<740){
//       var featurePad = (740-$(window).width())/2 + 'px';
//       $('#slider').css('marginLeft','-' +featurePad);
//       $('#slider-en').css('marginLeft','-' +featurePad);
//     }
//   }
//
//   if ($('body').hasClass('brew-top')) {
//     if ($(window).width()<768) {
//       $('.brand').each(function(){
//         $(this).on("click", function() {
//           $(this).next().slideToggle();
//         });
//       });
//       $('.cat').each(function(){
//         $(this).on("click", function() {
//           $(this).next().slideToggle();
//         });
//       });
//       $(".item").click(function(){
//         window.location=$(this).find("a").attr("href");
//         return false;
//       });
//     }else{
//       $(".brand").click(function(){
//         window.location=$(this).find("a").attr("href");
//         return false;
//       });
//     }
//   }
//
//   if ($('body').hasClass('brew-kokuryu')){
//       $('.brew-cat').each(function(i){
//         $(this).delay(400*i).animate({opacity:1}, 1000);
//       });
//
//
//   }
//   if ($('body').hasClass('brew-kuzuryu')){
//     $('.popup').hide();
//     // $(window).on('load',function() {
//       $('.brew-cat').each(function(j){
//         $(this).delay(400*j).animate({opacity:1}, 1000);
//       });
//       $('.brew-cat').each(function(e){
//         $(this).hover(function() {
//           $('.popup',this).fadeIn(400);
//         }, function() {
//           $('.popup',this).fadeOut(100);
//         });
//       });
//     // });
//   }
//   if ($('body').hasClass('brew-detail')){
//     $('.img-fade').slick({
//       infinite: true,
//       autoplay: true,
//       fade: true,
//       autoplaySpeed: 4000,
//       speed: 1200,
//       arrows: false
//     });
//     $('#comments h2').wrapInner('span');
//     $('#comments h2 span').removeClass();
//   }
//   if ($('body').hasClass('about')){
//     $('.slider').slick({
//       infinite: true,
//       autoplay: true,
//       fade: true,
//       autoplaySpeed: 4000,
//       speed: 1200,
//       arrows: false
//     });
//   }
});
//
//
//   $(window).on("load",function() {
//     if ($('body').hasClass('brew-top')) {
//       $('.brand').each(function(i){
//         $(this).delay(400*i).animate({opacity:1}, 1000);
//       });
//     }
//   });
